// extracted by mini-css-extract-plugin
module.exports = {"subscriptionAgreement":"privacy-agreement_subscriptionAgreement___ZoXF","dangerAgreement":"privacy-agreement_dangerAgreement__BENx9"};